export abstract class Environment {
  abstract readonly production: boolean;
  abstract readonly version: string;
  readonly uczenUrl: string = 'https://zeszyt.online/uczen/';
  readonly nauczycielUrl: string = 'https://zeszyt.online/nauczyciel/';
  readonly helpdeskUrl: string = 'https://zeszyt.online/helpdesk/';
  readonly logowanieUsos: boolean = false;
}
